export const FORM_ACTIONS_TEXTS = {
  SAVE_ERROR: 'Произошла ошибка при отправке!',
  SAVE_SUCCESS: 'Данные успешно отправлены!',
};
